import RegisterClient from './RegisterClient'

export const RegisterClientService = RegisterClient

